module.exports = __webpack_public_path__ + "static/media/neko-young-full.d637c313.png";